




















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Form, Field, Checkbox, Toast} from 'vant';
import SendVerificationCode from '@/components/SendVerificationCode.vue';
import registerApi from '@/api/register';
import commonApi from '@/api/common';
import { regExpObj } from '@/utils/regexp';
import { encrypt, getUrlParam, skipToMp } from '@/utils/common';
import { SOURCE_TYPE } from '@/utils/constant';

const isToApp = getUrlParam('isToApp'); // 去APP下载页面
const isToYYB = getUrlParam('isToYYB'); // 去应用宝下载页面

@Component({
  name: 'RegisterForm',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    SendVerificationCode
  }
})

export default class RegisterForm extends Vue {
  @Prop({
    type: String,
    default: ''
  }) invitationCode!: string;

  @Prop({
    type: String,
    default: ''
  }) successPath!: string;

  @Prop({
    type: String,
    default: ''
  }) appId!: string;

  @Prop({
    type: String,
    default: '成为俏租机会员，享受更多优惠'
  }) title!: string;

  @Prop({
    type: String,
    default: '注册'
  }) buttonText!: string;

  @Prop({
    type: String,
    default: 'orange'
  }) formTheme!: string;

  @Prop({
    type: Boolean,
    default: true // todo f 运营会来回切换俏机和俏租机（给到第三方的链接不变）
  }) isQzj!: boolean; // 区分注册成功的页面是跳转"俏租机"还是"俏机"，默认"俏租机"

  @Prop({
    type: String,
    default: ''
  }) sourceType!: string;

  phoneIcon = '';
  messageIcon = '';
  phoneNum = '';
  successPagePath = '';
  captcha = '';
  agreement = false;
  // 短信验证码相关请求参数
  codeRequestOptions = {
    url: commonApi.getMessageCode.url,
    method: commonApi.getMessageCode.method,
    isRepeatable: false,
    isLoading: true,
    sourceType: this.sourceType
  };

  $refs!: {
    loginForm: HTMLFormElement;
  };

  @Emit()
  public registerSuccess() {
    return true;
  }

  created() {
    this.phoneIcon = require(`../assets/images/merchant/phone_${this.formTheme}_icon.png`);
    this.messageIcon = require(`../assets/images/merchant/safety_${this.formTheme}_icon.png`);
    this.setSuccessPage();

    if (this.successPath) {
      this.successPagePath = this.successPath;
    }
  }

  // 设置跳转
  setSuccessPage() {
    switch (this.formTheme) {
      case 'blue':
        if (isToApp === 'true') {
          this.successPagePath = `/app/download?channel=common&invitationCode=${this.invitationCode}`;
        } else if (isToYYB === 'true') {
          this.successPagePath = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.qiaozuji.android';
        } else {
          this.successPagePath = `/merchant/new-success?isQzj=${this.isQzj}&invitationCode=${this.invitationCode}`;
        }

        break;
      case 'yellow':
        this.successPagePath = `/merchant/new-activity/success?invitationCode=${this.invitationCode}`;
        break;
      default:
        // orange
        this.successPagePath = `/register-success?invitationCode=${this.invitationCode}`;
        break;
    }
  }

  // 校验手机号码
  validatePhone(val: string) {
    return regExpObj.telephone.test(val);
  }

  // 校验短信验证码
  validateCode(val: string) {
    return regExpObj.sixCode.test(val);
  }

  // 发送验证码前先校验一下手机号码
  validateFunc() {

    this.$refs.loginForm.validate('validatePhone');

    return regExpObj.telephone.test(this.phoneNum);
  }

  // 登录
  register() {
    this.$refs.loginForm.validate()
      .then(() => {
        if(this.agreement) {
          // 表单校验通过后提交数据
          this.submitRegisterInfo();
        } else {
          Toast('请先阅读并勾选相关协议。');
        }
      });
  }

  goToaGreementPage(str: string) {
    if (this.sourceType === SOURCE_TYPE.jd) {
      this.$router.push({
        path: str === 'register' ? '/jd/register-agreement' : '/jd/privacy-agreement'
      });
      return;
    }

    if(str === 'register') {
      location.href =  location.origin + '/qzj/register-privacy'
    } else if(str === 'user') {
      location.href =  location.origin + '/qzj/user-privacy'
    }
  }

  // 跳转到注册成功页面
  // isOut参数表示是否当前系统的H5页面
  private goToRegisterSuccess(isOut = false) {
    if (isOut) {
      if (this.appId) {
        skipToMp(this.successPagePath, this.appId);
      } else {
        window.location.href = this.successPagePath;
      }
    } else {
      console.log(777,this.successPagePath);
      this.$router.push({
        path: this.successPagePath
      });
    }
  }

  // 提交登录数据给后台
  private submitRegisterInfo() {
    this.$http({
      url: registerApi.register.url,
      method: registerApi.register.method,
      params: {
        phoneNumEncrypt: encrypt(this.phoneNum),
        captcha: this.captcha,
        invitationCode: this.invitationCode
      },
      sourceType: this.sourceType
    }).then(() => {
      this.$toast.success('注册成功');
      this.registerSuccess();
      setTimeout(() => {
        this.$toast.clear();
        this.goToRegisterSuccess(this.successPagePath.startsWith('http') || !!this.appId);
      }, 700);
    });
  }
}

